import React, { useEffect, useState, useCallback, useRef, memo } from 'react';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import Keyboard from '@components/KeyboardV2';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { LABEL } from '../../../veriables';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import cn from 'classnames';
import Styles from '../openCheckPopUp/createtableCopy.module.scss';
import { TouchableButton, TouchableDiv } from '../../common/Touchable/index';

const GuestCountSection = memo(({ count, setCount, serverAppTheme, orderingPortraitOrientation }) => {
  return (
    <div className={cn("col-12 p-0 mx-0 mb-1", !orderingPortraitOrientation ? 'row' : '')}>
      {!orderingPortraitOrientation && (
        <div 
          className="col-6 p-0 row mx-0 my-auto"
          style={{ textAlign: 'initial' }}
        />
      )}
      <div className={cn(!orderingPortraitOrientation ? 'justify-content-end col-6 p-0 row' : 'justify-content-center d-flex p-0 pr-4')}>
        <div className={cn("fs_24 fw-400 my-1", !orderingPortraitOrientation ? 'text-left pl-4 ml-2' : '')} style={{ color: serverAppTheme?.primary_text }}>
          {LABEL().GUEST_COUNT}
        </div>
        <div className="row ml-3">
          <TouchableButton className={cn(Styles.incDecButton, 'rounded mr-2')} style={{ background: serverAppTheme?.primaryBtn, color: serverAppTheme?.btn_font_color }} onClick={() => count > 1 && setCount(count - 1)} disabled={count <= 1}>
            <i className="fas fa-minus" />
          </TouchableButton>
          <div className="fs_24 fw-700 d-flex align-items-center mx-2" style={{ color: serverAppTheme?.primary_text, width: '15px' }}>{count}</div>
          <TouchableButton className={cn(Styles.incDecButton, 'rounded ml-3')} style={{ background: serverAppTheme?.primaryBtn, color: serverAppTheme?.btn_font_color }} onClick={() => setCount(count + 1)}>
            <i className="fas fa-plus" />
          </TouchableButton>
        </div>
      </div>
    </div>
  );
});

const ActionButtons = memo(({ isDriveThru, serverAppTheme, onCloseTable, onContinue, orderingPortraitOrientation }) => {
  return (
    <div className={cn('col-12 d-flex align-items-center justify-content-center position-fixed bottom-0 start-0', Styles.btnPosition)}>
      <div className={cn("pr-1", orderingPortraitOrientation ? 'pl-0 col-6' : 'col-5')}>
        <TouchableButton className={cn('px-0 mb-3 mt-2 rounded btn-ripple fs_24 fw-600 w-100', !orderingPortraitOrientation ? 'btn44' : 'btn68')} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }} onClick={() => onCloseTable('click')} rippleEffect={true}>
          {isDriveThru ? LABEL().DT_CANCEL : LABEL().CANCEL}
        </TouchableButton>
      </div>
      <div className={cn("pl-1", orderingPortraitOrientation ? 'pr-0 col-6' : 'col-5')}>
        <TouchableButton className={cn('btn-ripple fs_24 fw-600 w-100 d-flex align-items-center justify-content-center mb-3 mt-2', !orderingPortraitOrientation ? 'btn44' : 'btn68')} style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }} onClick={onContinue} rippleEffect={true}>
          <span className={cn("fw-600 w-100", !orderingPortraitOrientation ? 'fs_24' : 'fs_28')}>{isDriveThru ? LABEL().DT_CONTINUE : LABEL().OT_CONTINUE}</span>
        </TouchableButton>
      </div>
    </div>
  );
});

const KeyboardWrapper = memo(({ setKeyboardType, onClickBtn, inputName, deviceGroup, setSwipedDown, orderingPortraitOrientation, currentMaxLength, setIsDoneClick }) => {
  return (
    <div className={cn('w-100 align-items-end position-fixed', !orderingPortraitOrientation ? 'p-0' : 'px-3')} style={{ bottom: !orderingPortraitOrientation ? '70px' : '', left: '0', outline: 'none', top: orderingPortraitOrientation ? '39%' : '' }}>
      <Keyboard
        setKeyboardType={setKeyboardType}
        onClickBtn={onClickBtn}
        type={inputName === 'phoneNumber' || (deviceGroup?.inputFields?.phoneNumberEnabled && !deviceGroup?.inputFields?.nameEnabled) ? 'numericAlpha' : 'textDefaultCaps'}
        closeKeyboard={() => setSwipedDown(false)}
        btnSize="fs-18"
        customClass={`h-auto mt-auto p-2`}
        maxLength={currentMaxLength}
        spacebtn={orderingPortraitOrientation && Styles.spacebtn}
        screenType="checkCreate"
        isAlphaNumericFlag={true}
        setIsDoneClick={setIsDoneClick}
        tableKeyHeight={true}
        callApi={true}
      />
    </div>
  );
});

const TabInputSection = memo(({ 
  submitRef, name, placeholder, isCounter, isDriveThru, isCallCenter, deviceGroup, 
  serverAppTheme, countryCode, phoneNumberMaxLength, maxLength, orderingPortraitOrientation, 
  handleCountryCodeChange, setErrorPopUp, isTipOnlyEnabled, isOpen 
}) => {
  const [keyboardType, setKeyboardType] = useState(
    deviceGroup?.inputFields?.phoneNumberEnabled && !deviceGroup?.inputFields?.nameEnabled
      ? 'numericAlpha' : 'numericAlpha'
  );
  const [typed, setTyped] = useState({});
  const [inputs, setInputs] = useState({ [name]: '' });
  const [inputName, setInputName] = useState(
    deviceGroup?.inputFields?.phoneNumberEnabled && !deviceGroup?.inputFields?.nameEnabled ? 'phoneNumber' : name
  );
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [isDoneClick, setIsDoneClick] = useState(false);

  const typedRef = useRef(typed);
  typedRef.current = typed;
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;

  useEffect(() => {
    if (isCounter && isOpen) {
      const counterUser = window.sessionStorage.getItem('counterName') || '';
      const counterPhone = window.sessionStorage.getItem('counterPhone') || '';
      const formattedPhone = getFormatedPhoneNumber(counterPhone);
      setTyped({ tabName: counterUser, phoneNumber: formattedPhone });
      setInputs({ tabName: counterUser, phoneNumber: formattedPhone });
    }
  }, [isOpen, isCounter]);

  const submitInternal = useCallback((guestCount, validate, onSubmit) => {
    const validateData = { ...typedRef.current, guestNumber: guestCount };
    validate(validateData)
      .then(res => {
        if (deviceGroup?.inputFields?.phoneNumberRequired && deviceGroup?.inputFields?.phoneNumberEnabled && !inputsRef.current?.phoneNumber) {
          setErrorPopUp({ res: 'Phone number required', noErrorTxt: true });
          return;
        } else if (Number(countryCode) === 1 && inputsRef.current?.phoneNumber && inputsRef.current?.phoneNumber?.length !== 12) {
          setErrorPopUp({ res: `Phone number length must be ${phoneNumberMaxLength}`, noErrorTxt: true });
          return;
        }
        if (!res?.isCheckModalOpenFlag) onSubmit(validateData);
      })
      .catch(err => err.message?.length > 0 && setErrorPopUp({ res: err.message, noErrorTxt: true }));
  }, [deviceGroup, countryCode, phoneNumberMaxLength, setErrorPopUp]);

  submitRef.current = submitInternal;

  const onClickBtn = useCallback(e => {
    const currentTyped = typedRef.current;
    const currentInputName = inputNameRef.current;
    if (e === '{continue}') return;
    const value = e === '{bksp}'
        ? { ...currentTyped, [currentInputName]: currentTyped[currentInputName]?.slice(0, -1) }
        : { ...currentTyped, [currentInputName]: (currentTyped[currentInputName] || '').concat(e) };
    setTyped(value);
    setInputs(prev => ({
      ...prev,
      [currentInputName]: currentInputName === 'phoneNumber' && Number(countryCode) === 1
          ? getFormatedPhoneNumber(value[currentInputName]) : value[currentInputName]
    }));
  }, [countryCode]);

  const currentMaxLength = inputName === 'phoneNumber' ? (inputs.phoneNumber?.includes('-') ? 12 : phoneNumberMaxLength) : maxLength;

  return (
    <>
      <div className={cn('col-12 p-0 my-1 mb-0 position-relative', isTipOnlyEnabled ? 'px-12' : '')}>
        <input
          id={name}
          className={cn(Styles.inputField, 'col-12 fs_26 form-control py-2 text-left')}
          style={{ background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder, outline: 'none', boxShadow: 'none', height: orderingPortraitOrientation ? '64px' : '' }}
          placeholder={placeholder}
          value={isDriveThru ? (inputs[name] || window.sessionStorage.getItem('counterName') || '') : (inputs[name] || '')}
          onFocus={() => { setSwipedDown(true); setInputName(name); (isCounter || isDriveThru) && setKeyboardType('textWithoutNumeric'); }}
          readOnly
        />
        {inputs[name]?.length > 0 && (
          <TouchableDiv className="position-absolute" style={{ right: '18px', top: !orderingPortraitOrientation ? '6px' : '15px' }} onClick={() => { setInputName(name); setInputs(prev => ({...prev, [name]: ''})); setTyped(prev => ({...prev, [name]: ''})); }}>
            <Cross fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}
      </div>

      {deviceGroup?.inputFields?.phoneNumberEnabled && (
        <div className={cn('col-12 p-0 my-2 position-relative')}>
          <PhoneNumberComponent countryCode={countryCode} handleCountryCodeChange={e => { handleCountryCodeChange(e); setInputs(prev => ({...prev, phoneNumber: ''})); setTyped(prev => ({...prev, phoneNumber: ''})); }} maxMenuHeight={200} isCounter={true} serverAppTheme={serverAppTheme} isDriveThru={true} />
          <input
            id="phoneNumber"
            className={cn(Styles.countertopInput, 'col-12 form-control py-2 rounded-0')}
            style={{ borderBottom: serverAppTheme?.inputBorder_Bottom, background: serverAppTheme?.inputBg, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder }}
            type="text"
            placeholder={deviceGroup?.inputFields?.phoneNumberRequired ? `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().REQUIRED})` : `${LABEL().ENTER_PHONE_NUMBER} (${LABEL().OPTIONAL})`}
            value={inputs['phoneNumber'] || ''}
            onFocus={() => { setSwipedDown(true); setKeyboardType((isCounter || isDriveThru || isCallCenter) ? 'numericAlpha' : 'number'); setInputName('phoneNumber'); }}
            readOnly
          />
          {inputs['phoneNumber']?.length > 0 && (
            <TouchableDiv className="position-absolute" style={{ right: '18px', top: !orderingPortraitOrientation ? '6px' : '15px' }} onClick={() => { setInputs(prev => ({...prev, phoneNumber: ''})); setTyped(prev => ({...prev, phoneNumber: ''})); setInputName('phoneNumber'); }}>
              <Cross fill={serverAppTheme?.iconcolor} />
            </TouchableDiv>
          )}
        </div>
      )}

      {isSwipedDown && (
        <KeyboardWrapper
          setKeyboardType={setKeyboardType}
          onClickBtn={onClickBtn}
          inputName={inputName}
          deviceGroup={deviceGroup}
          setSwipedDown={setSwipedDown}
          orderingPortraitOrientation={orderingPortraitOrientation}
          currentMaxLength={currentMaxLength}
          setIsDoneClick={setIsDoneClick}
        />
      )}
    </>
  );
});

const AddTabModal = (props) => {
  const {
    type, maxLength, name, placeholder, onSubmit, validate, hideGuestCount = false,
    countryCode, handleCountryCodeChange, phoneNumberMaxLength, deviceGroup,
    orderingPortraitOrientation, onCloseTable, serverAppTheme, isCounter,
    isDriveThru, isCallCenter, isTipOnlyEnabled, setErrorPopUp
  } = props;

  const [count, setCount] = useState(deviceGroup?.defaultGuestCount || 1);
  const submitRef = useRef();

  const handleContinue = useCallback(() => {
    if (submitRef.current) {
      submitRef.current(hideGuestCount ? 1 : count, validate, onSubmit);
    }
  }, [count, hideGuestCount, validate, onSubmit]);

  return (
    <div className={cn(!orderingPortraitOrientation ? 'col-10 p-0 h-100 d-flex flex-column m-auto' : 'col-12 p-0 h-100 d-flex flex-column m-0')}>
      <div className={cn('row mb-2  mx-3 justify-content-center align-self-center justify-self-center mb-2 align-items-center', deviceGroup?.inputFields?.phoneNumberEnabled ? '' : 'pt-20', isTipOnlyEnabled ? 'w-100' : '')}
           style={{top: orderingPortraitOrientation ? '18vh' : '', position: orderingPortraitOrientation ? 'absolute' : ''}}>
        
        {!hideGuestCount && !isTipOnlyEnabled && (
          <GuestCountSection count={count} setCount={setCount} serverAppTheme={serverAppTheme} orderingPortraitOrientation={orderingPortraitOrientation} />
        )}

        <TabInputSection
          submitRef={submitRef}
          name={name}
          placeholder={placeholder}
          isCounter={isCounter}
          isDriveThru={isDriveThru}
          isCallCenter={isCallCenter}
          deviceGroup={deviceGroup}
          serverAppTheme={serverAppTheme}
          countryCode={countryCode}
          phoneNumberMaxLength={phoneNumberMaxLength}
          maxLength={maxLength}
          orderingPortraitOrientation={orderingPortraitOrientation}
          handleCountryCodeChange={handleCountryCodeChange}
          setErrorPopUp={setErrorPopUp}
          isTipOnlyEnabled={isTipOnlyEnabled}
          isOpen={props.isOpen}
        />

        <ActionButtons
          isDriveThru={isDriveThru}
          serverAppTheme={serverAppTheme}
          onCloseTable={onCloseTable}
          onContinue={handleContinue}
          orderingPortraitOrientation={orderingPortraitOrientation}
        />
      </div>
    </div>
  );
};

export default memo(AddTabModal);
